exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-addon{\r\n    min-width: 41px;\r\n}\r\n.page-header{\r\n    padding-top: 9px;\r\n}\r\n\r\n.inner-check-wrapper .CheckAmountDiv {\r\n    right: 2.5em;\r\n    top: 7.8em;\r\n}\r\n\r\n.bankName_sub{\r\n    top: 14.5em;\r\n    left: 2.1em;\r\n    width: 300px;\r\n}\r\n.bankName_sub span{\r\n    font-size: 10px;\r\n}\r\n\r\n.text-wrap {\r\n    word-wrap: break-word;\r\n    font-size: 10px !important;\r\n}\r\n\r\n.contact_sec{    padding-bottom: 18px;}\r\n.contact_sec a{    color: #f5821f;}\r\n.contact_sec a:hover{    color: #fff;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/invoice-bankauth/invoice-bankauth.component.css
// module id = ../../../../../src/app/invoice-bankauth/invoice-bankauth.component.css
// module chunks = main